/* Pagination footer for one FTE Details table — same look as the AOP Budget Details footer.
   Stateless: the owning table holds page/pageSize. */
import React from "react";
import { TABLE_FONT, TH_BG_BAND } from "../../reportTableConfig";

const FONT = TABLE_FONT;
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const bar = { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderTop: "1px solid #E2E8F0", background: "#FAFAFA", gap: 12, flexWrap: "wrap" };
const txt = { fontSize: 12, color: "#6B7280", fontFamily: FONT, whiteSpace: "nowrap" };
const sizeSel = { height: 28, border: "1px solid #E2E8F0", borderRadius: 6, fontSize: 12, color: "#374151", padding: "0 6px", background: "#fff", cursor: "pointer", fontFamily: FONT };
const btnBase = {
  minWidth: 30, height: 28, padding: "0 6px", borderRadius: 6, fontSize: 12, fontFamily: FONT,
  display: "inline-flex", alignItems: "center", justifyContent: "center",
};
const btn = (disabled) => ({
  ...btnBase,
  border: "1px solid #E2E8F0",
  background: "#fff",
  color: disabled ? "#94A3B8" : "#374151",
  cursor: disabled ? "default" : "pointer",
  opacity: disabled ? 0.35 : 1,
});
const btnActive = {
  ...btnBase,
  border: `1px solid ${TH_BG_BAND}`,
  background: TH_BG_BAND,
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
};

export default function FtePaginationBar({ page, pageSize, totalRows, onPageChange, onPageSizeChange }) {
  if (totalRows === 0) return null;
  const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
  const rangeStart = (page - 1) * pageSize + 1;
  const rangeEnd = Math.min(page * pageSize, totalRows);
  const pageNums = totalPages <= 7
    ? Array.from({ length: totalPages }, (_, i) => i + 1)
    : [...new Set([1, totalPages, page, page - 1, page + 1, page - 2, page + 2])]
        .filter((p) => p >= 1 && p <= totalPages)
        .sort((a, b) => a - b);

  return (
    <div style={bar}>
      <span style={txt}>{`${rangeStart}–${rangeEnd} of ${totalRows} rows`}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={txt}>Per page</span>
        <select style={sizeSel} value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))}>
          {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
        <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
          <button type="button" style={btn(page === 1)} disabled={page === 1} onClick={() => onPageChange(1)}>«</button>
          <button type="button" style={btn(page === 1)} disabled={page === 1} onClick={() => onPageChange(page - 1)}>‹</button>
          {pageNums.map((p, i) => (
            <React.Fragment key={p}>
              {i > 0 && pageNums[i - 1] < p - 1 && <span style={{ ...txt, padding: "0 4px" }}>…</span>}
              <button type="button" style={p === page ? btnActive : btn(false)} onClick={() => onPageChange(p)}>{p}</button>
            </React.Fragment>
          ))}
          <button type="button" style={btn(page === totalPages)} disabled={page === totalPages} onClick={() => onPageChange(page + 1)}>›</button>
          <button type="button" style={btn(page === totalPages)} disabled={page === totalPages} onClick={() => onPageChange(totalPages)}>»</button>
        </div>
      </div>
    </div>
  );
}
